export default __webpack_public_path__ + "ac1b61ef59ab362905912eccfb9debec.svg";